<template>
<div>
<div class="modal " id="lineModal" tabindex="-1" role="dialog">
<div class="modal-dialog modal-dialog-centered" role="document">
<div class="modal-content">
<div  class="modal-header text-nowrap">
    <h4 class="modal-title">
    <i class="fas fa-user-tag mr-1" aria-hidden="true"></i>
    <strong>CREA LINEA FORNITORE</strong></h4>
</div>
<div class="modal-body" >
<form v-on:submit.prevent="saveData()">

    <div class="form-group">
    <input required type="text" v-focus class="form-control" id="inputLine" placeholder="Linea fornitore" v-model="line">
    <small style="color:red" v-if="err" id="codeHelp" class="form-text">
    <strong>LINEA FORNITORE ESISTENTE</strong>
    </small>
    
    
    </div>
    <button @click="err=false" data-dismiss="modal" type="button" class="btn btn-secondary float-left">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
      Annulla</button>
    <button type="submit" class="btn btn-primary float-right">
       <i class="fas fa-save mr-2" aria-hidden="true"></i>   
      SALVA</button>

</form>
</div>
</div>
</div>
</div>
  
</div>

</template>

<script>

import api             from "@/api";
export default {
   props : ['supplierId'],
  components: {},
  data() {
    return {
      line : '',
      err  : false

      
    };
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  methods: 
  {
    
    async saveData()
    {
    
    var sp   = {'sp'   : 'spCreateSupplierLine'}      
    var data = {'line' : this.line, 'supplierId' : this.supplierId}
    var json = Object.assign(data, sp)

    await api.post(json).then(res => {
          
      

          if(res.status==200)
            {
                          
            if(res.data.recordsets[0][0].lineId==0)
            {
                this.err = true
                return
            }
            this.$emit('update')
                         
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });




      }
}

}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
</style>


